import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { ErrorMessage, Loading, withValidPermission } from '@Components';
import { useFetchData } from '@CustomHooks';
import { Permission } from '@Models';
import { bopsApi } from '@Network';
import { RootState } from '@Store';
import Supplier from './suppliers';

interface SupplierContainerProps {
  canManage: boolean;
}

const SupplierContainer = ({ canManage }: SupplierContainerProps) => {
  const { t } = useTranslation();

  const { data, isLoading, error, refetch } = useFetchData(bopsApi.getSuppliers);

  if (isLoading) return <Loading title={t('Supplier.Loading')} />;

  if (error || !data) {
    return <ErrorMessage internalMessage={`Unable to get suppliers: ${error}`} />;
  }

  const supplierUpdated = () => {
    refetch();
  };

  return <Supplier suppliers={data} supplierUpdated={supplierUpdated} canManage={canManage} />;
};

const mapStateToProps = (state: RootState) => {
  const { authorization } = state;
  return { canManage: (authorization.permissions ?? []).includes(Permission.ManageSuppliers) };
};

export default withValidPermission(connect(mapStateToProps)(SupplierContainer), [
  Permission.ManageSuppliers,
  Permission.ViewSuppliers,
]);
